import { isProduction } from '@application/env';
import { i18n } from '@application/i18n';
import type { FC } from 'react';
import * as Styled from './styled';
import type { LocaleSwitcherProps } from './types';

export * from './types';

const isProd = isProduction();

export const LocaleSwitcher: FC<LocaleSwitcherProps> = (props) => {
  const { parentColor, label, onClick, loading } = props;

  return (
    <>
      <Styled.LocaleButton
        color="white"
        onClick={onClick}
        onDoubleClick={() => {
          if (isProd) {
            return;
          }

          i18n.changeLanguage('cimode');
        }}
        outlined
        shrink
        parentColor={parentColor}
        loading={loading}
      >
        {label}
      </Styled.LocaleButton>
    </>
  );
};
